import Mutations from '../../odata/mutations';

export default { ...new Mutations('processCheckSheet'), ...new Mutations('processCheckSheets') };
